import React from 'react';
import { Paragraph, Span } from '../../../../components/typography';
import DeliveryOption from './DeliveryOption';
import { Row, Col } from '../../../../components/grid';
import { Price } from '../../../../containers/commerce';
import TimeElement from '../../../../components/Date/Time';
import DateElement from '../../../../components/Date/DateElement';
import { createTime, createDate } from '../../../../containers/Date';
import { dateTypes } from '../../../../features/commerce/delivery/dates';
import { deliveryTypes } from '../../../../features/commerce/delivery';
import ReadMore from '../../../../components/ReadMore';

const DeliveryDate = createDate(deliveryTypes.no)(dateTypes.delivery)(DateElement);
const ReturnDate = createDate(deliveryTypes.no)(dateTypes.pickup)(DateElement);
const DeliveryTime = createTime(deliveryTypes.no)(dateTypes.delivery)(TimeElement);
const ReturnTime = createTime(deliveryTypes.no)(dateTypes.pickup)(TimeElement);


export default ({
  chosen,
  error,
  onChoose,
  hideError,
  component: DeliveryOptionComponent = DeliveryOption,
  step2,
}) => (
  <DeliveryOptionComponent
    onChoose={onChoose}
    choosen={chosen}
    error={error}
    headline="Henter selv - med returret"
    subheadline="på ubrudte fustager"
    hideError={hideError}
    className="noDeliveryChoice"
  >
    <Row>
      <Col xs={12} md={step2 ? 12 : 6} padding="0px 15px">
        <Paragraph fontSize={step2 && 13}>
          Jeg afhenter selv varerne på Park Alle 352A i 2605 Brøndby.
          Lageret har åbent alle hverdage 7:00 til 16:00.
        </Paragraph>
        <ReadMore>
          <Paragraph fontSize="12px">
            Du kan betale online på forhånd eller med betalingskort på lageret når du afhenter.
            Ekspeditionen går hurtigst hvis du har betalt på forhånd.
          </Paragraph>
          <Paragraph fontSize="12px">
            Online betaling hæves først efter modregning af evt. pant og/eller efter aflevering af lejet fadølsanlæg.
            Der hæves kun det faktiske forbrug.
          </Paragraph>
          <Paragraph fontSize="12px">
            Returnerer du senere tomme og/eller ubrudte fustager, tilbagebetaler vi pant samt vareprisen, på nær <Price varenr="641" /> pr. fustage.
            Returbeløbet tilbageføres direkte til dit betalingskort. Fyldte fustager skal returneres inden 14 dage. Tomme fustager kan du beholde så længe du vil.
          </Paragraph>
          <Paragraph fontSize="12px">
            Spørgsmål til bestilling ring 43 27 00 00.
          </Paragraph>
        </ReadMore>
      </Col>
      <Col xs={12} md={step2 ? 12 : 6} padding="0px 15px">
        <Row greyLight={step2 && true}>
          <Col xs={12} padding="10px 15px 15px 15px">
            <DeliveryDate timeComponent={<DeliveryTime />} isSmall={step2}>
              <Span bold>Afhentningsdato:</Span>
            </DeliveryDate>
            <ReturnDate timeComponent={<ReturnTime />} isSmall={step2}>
              Returdato:
            </ReturnDate>
          </Col>
        </Row>
      </Col>
    </Row>
  </DeliveryOptionComponent>
);
